<div class="modal-header">
  <h5 class="modal-title"><i class="fas fa-book"></i> &nbsp;<ng-container i18n>Template Dictionary</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <mat-tab-group [color]="'accent'">
    <mat-tab label="Template Tags" i18n-label>
      <div class="row no-margin">
        <div *ngFor="let tag of activeTags" class="col-sm-6 text-left">
          <button
            [matTooltip]="tag.tooltip"
            matTooltipPosition="above"
            (click)="addTag(tag.key)"
            type="button"
            class="data-item"
          >
            {{ tag.key }}
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
